import { createContext } from 'react';
import {
  BaseSortableProps,
  ISortableCard,
} from '../@types/sortable-list-types';
export const SortableListContext = createContext<BaseSortableProps<any>>(
  {} as BaseSortableProps<any>
);
export const SortableSubListContext = createContext<ISortableCard<any>>(
  {} as ISortableCard<any>
);
